export enum DonationStateEnum {
    input,
    comfirm,
    payment 
  }